// extracted by mini-css-extract-plugin
export default {"notification-dot-container":"NotificationDot_notification-dot-container__u7RzB","notification-dot":"NotificationDot_notification-dot__Q4fQL"};